module.exports = __webpack_public_path__ + "static/media/smyga.29c7b812.mp3";